import React from 'react';
import classes from './Item.css'
const Item = (props) =>{
    


    return (
        <tr className={props.itemObject.markForDelete ?'red':'white'}>
            <td>{props.itemObject.id}</td>
            <td>{props.itemObject.name}</td>
            <td><img width="100" src={props.itemObject.url} alt={props.itemObject.name+' image'}/></td>
            <td>
                <button onClick={()=>props.itemObject.toggleMarkForDelete(props.itemObject)}>Delete This</button>
                &nbsp;
                <button onClick={()=>props.itemObject.toggleMarkForUpdate(props.itemObject)}>Update This</button>
            </td>

        </tr>
    )
}
export default Item;


// WEBPACK FOOTER //
// ./src/Components/Item/Item.js